export default __webpack_public_path__ + "media/133ffd7f82b35047a1c3dbd3ed94f88031f0a0aa91184fdd9437d542b3df3838.svg";